import type { AHCREvent } from 'domain/ahcr-event'
import { VehicleCounts } from 'domain/vehicle-counts'
import { CameraPerformance } from 'domain/camera-performance'
export type { AHCREvent }

export interface AHCREventQueryParams {
  clientId?: string | null
  page?: number
  pageSize?: number
  sortField?: string
  sortOrder?: 'asc' | 'desc'
  search?: string
  startDate: Date
  endDate: Date
}

export interface AHCREventCountResponse {
  cameraPerformance: CameraPerformance[]
  vehiclePerformance: VehicleCounts
}

export const emptyAHCREvent: AHCREvent = {
  cameraName: '',
  uId: '',
  hat: '',
  bag: '',
  mask: '',
  glass: '',
  gender: '',
  things: '',
  ageGroup: '',
  hairStyle: '',
  jacketType: '',
  jacketColor: '',
  trousersType: '',
  trousersColor: '',
  closeUpImageUrl: '',
  detectionImageUrl: '',
  createdDate: '',
  stayDuration: null,
}

// Value mappings
export const genderMapping = {
  male: 'Masculino',
  female: 'Feminino',
  unknown: 'Desconhecido',
}

export const booleanMapping = {
  true: 'Sim',
  false: 'Não',
  yes: 'Sim',
  no: 'Não',
  unknown: 'Desconhecido',
}

export const colorMapping = {
  white: 'Branco',
  black: 'Preto',
  red: 'Vermelho',
  blue: 'Azul',
  green: 'Verde',
  yellow: 'Amarelo',
  brown: 'Marrom',
  gray: 'Cinza',
  grey: 'Cinza',
  silver: 'Prata',
  purple: 'Roxo',
  pink: 'Rosa',
  cyan: 'Ciano',
  orange: 'Laranja',
  unknown: 'Desconhecido',
}

export const jacketTypeMapping: Record<string, string> = {
  shortsleeve: 'Manga Curta',
  longsleeve: 'Manga Longa',
  unknown: 'Desconhecido',
}

export const trousersTypeMapping: Record<string, string> = {
  shorttrousers: 'Shorts',
  longtrousers: 'Calça',
  unknown: 'Desconhecido',
}

export const hairStyleMapping: Record<string, string> = {
  longhair: 'Longo',
  shorthair: 'Curto',
  unknown: 'Desconhecido',
}

export const ageGroupMapping: Record<string, string> = {
  child: 'Criança',
  young: 'Jovem',
  middle: 'Adulto',
  old: 'Idoso',
  unknown: 'Desconhecido',
}

// Filter options
export const genderOptions = [
  { label: 'Masculino', value: 'male' },
  { label: 'Feminino', value: 'female' },
  { label: 'Desconhecido', value: 'unknown' },
]

export const hatOptions = [
  { label: 'Sim', value: 'yes' },
  { label: 'Não', value: 'no' },
  { label: 'Desconhecido', value: 'unknown' },
]

export const ageGroupOptions = [
  { label: 'Criança', value: 'child' },
  { label: 'Jovem', value: 'young' },
  { label: 'Adulto', value: 'middle' },
  { label: 'Idoso', value: 'old' },
  { label: 'Desconhecido', value: 'unknown' },
]

export const hairStyleOptions = [
  { label: 'Cabelo Longo', value: 'longhair' },
  { label: 'Cabelo Curto', value: 'shorthair' },
  { label: 'Desconhecido', value: 'unknown' },
]

export const jacketTypeOptions = [
  { label: 'Manga Curta', value: 'shortsleeve' },
  { label: 'Manga Longa', value: 'longsleeve' },
  { label: 'Desconhecido', value: 'unknown' },
]

export const trousersTypeOptions = [
  { label: 'Shorts', value: 'shorttrousers' },
  { label: 'Calça', value: 'longtrousers' },
  { label: 'Desconhecido', value: 'unknown' },
]

export const colorOptions = [
  { label: 'Branco', value: 'white' },
  { label: 'Preto', value: 'black' },
  { label: 'Vermelho', value: 'red' },
  { label: 'Azul', value: 'blue' },
  { label: 'Verde', value: 'green' },
  { label: 'Amarelo', value: 'yellow' },
  { label: 'Marrom', value: 'brown' },
  { label: 'Cinza', value: 'gray' },
  { label: 'Prata', value: 'silver' },
  { label: 'Roxo', value: 'purple' },
  { label: 'Rosa', value: 'pink' },
  { label: 'Laranja', value: 'orange' },
  { label: 'Desconhecido', value: 'unknown' },
]
